<template>
  <div>
    <div class="bg">
      <div class="bc">
        <div class="up_space"/>
        <img class="img_1" src="/img/image/home/t_12.png" loading="lazy" alt="分店資訊">
        <div class="down_space"/>
      </div>
    </div>
    <BranchInfo v-for="(item,index) in itemList" :index="index" :item="item"/>
  </div>
</template>

<script>
import BranchInfo from "../components/BranchInfo";
import {getStores} from "@/api/api";

export default {
  name: "Stage_8",
  components: {BranchInfo},
  data() {
    return {
      itemList: [],
    };
  },
  created() {
    this.getStores();
  },
  methods: {
    async getStores() {
      let response = await getStores();
      this.itemList = response.data;
    },
  }
}
</script>

<style lang="scss" scoped>

.bg {
  background-image: url('/img/image/background/bg_s12.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  text-align: center;
}


.up_space {
  height: 60px;
}

@media (max-width: 992px) {
  .up_space {
    height: 50px;
  }
}

@media (max-width: 576px) {
  .up_space {
    height: 30px;
  }
}

@media (max-width: 360px) {
  .up_space {
    height: 24px;
  }
}


// 文字 分店資訊
.img_1 {
  width: 692px;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
  content: url('/img/image/home/t_12.png');
}

@media (max-width: 1440px) {
  .img_1 {
    margin-left: 300px;
  }
}

@media (max-width: 992px) {
  .img_1 {
    margin: 0;
    width: 47vw;
  }
}

@media (max-width: 576px) {
  .img_1 {
    width: 58vw;
  }
}

@media (max-width: 360px) {
  .img_1 {
    width: 232px;
    content: url('/img/image/home/t_12_min.png');
  }
}

.down_space {
  height: 45px;
}

@media (max-width: 992px) {
  .down_space {
    height: 50px;
  }
}

@media (max-width: 576px) {
  .down_space {
    height: 30px;
  }
}

@media (max-width: 360px) {
  .down_space {
    height: 10px;
  }
}


</style>
